import { createCRUDHook } from './createCRUDHook';
import { MaterialDto, MaterialListItem } from 'utils/models';
import {
  TLKP_MATERIAL,
  TLKP_MATERIAL_WITH_PRODUCATION_PROCESS,
} from './apiEndPoints';
import { prepareQueryParams } from 'utils';

interface MaterialCustomOperations {
  getMaterialData: () => Promise<MaterialListItem[]>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  MaterialDto,
  MaterialListItem[],
  MaterialCustomOperations
>({
  entityName: 'Material',
  endpoint: TLKP_MATERIAL,

  customOperations: (auth) => ({
    getMaterialData: async (): Promise<MaterialListItem[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TLKP_MATERIAL + TLKP_MATERIAL_WITH_PRODUCATION_PROCESS,
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const MaterialContext = Context;
export const useMaterialManager = useManager;
export const useMaterial = useConsumer;
